import { universalServices } from "@/services/UniversalServices";
import { Permission } from "@/types/Permissions.interface";
import { makeAutoObservable, runInAction } from "mobx";
import { userStore } from "./UserStore";
import { addNotification } from "@/utils/addNotification";

class PermissionsStore {
  permissions: Permission[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  async setPermissions() {
    try {
      const response = await universalServices.getData<Permission[]>("permissions", "get-permissions");

      runInAction(() => {
        if (response.data) {
          this.permissions = response.data;
        }
      });
    } catch (e) {
      const message = e instanceof Error ? e.message : typeof e === "string" ? e : "Unknown error";
      addNotification({ message: message, type: "error" });
      runInAction(() => {
        this.permissions = [];
      });
    }
  }

  getPermissions(
    type: keyof Permission["typePermissions"],
  ): Permission["typePermissions"][keyof Permission["typePermissions"]] {
    const found = this.permissions.find((perm) => perm.roleId === userStore.role);
    if (found) {
      return found.typePermissions[type];
    }
    return { add: false, edit: false, delete: false };
  }

  getPermissionsByRoleId(roleId: number): Permission | null {
    const found = this.permissions.find((perm) => perm.roleId === roleId);
    return found || null;
  }

  clear() {
    this.permissions = [];
  }
}

export const permissionsStore = new PermissionsStore();
